import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAoMudarEtapa } from "./useAoMudarEtapa";

const API = "/api";
// Reserva: quem atualiza é a mudança de etapa (useAoMudarEtapa). Os tempos só
// mudam quando um pedido de hoje ganha um carimbo, e todo carimbo chega pela
// lista da tela — a leitura por relógio fica para a virada do dia.
const INTERVALO_MS = 5 * 60000;

const VAZIO = { media_seg: null, pedidos: 0 };
export const TEMPOS_VAZIOS = { aceite: VAZIO, producao: VAZIO, espera_saida: VAZIO, transito: VAZIO };

/**
 * Tempo médio de cada etapa hoje (GET /delivery/tempos-etapas). Relê quando um
 * pedido muda de etapa — nesta tela ou em qualquer outra, porque a lista da
 * tela é relida a cada 5 s — e, de reserva, a cada 5 minutos.
 */
export function useTemposEtapas(assinatura = null) {
  const [tempos, setTempos] = useState(TEMPOS_VAZIOS);
  const vivo = useRef(true);

  const buscar = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${API}/delivery/tempos-etapas`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (vivo.current && data) setTempos({ ...TEMPOS_VAZIOS, ...data });
    } catch (_) {
      // Mantém a última leitura: métrica de apoio não pode piscar por falha de rede.
    }
  }, []);

  useEffect(() => {
    vivo.current = true;
    buscar();
    const t = setInterval(buscar, INTERVALO_MS);
    return () => { vivo.current = false; clearInterval(t); };
  }, [buscar]);

  useAoMudarEtapa(assinatura, buscar);

  return tempos;
}
